"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tombstone = exports.isVisible = exports.equivalent = exports.isTombstone = exports.decodeRow = exports.SweepState = exports.MarkerMeta = exports.MarkerTombstone = exports.MarkerRow = exports.Bit = exports.Percent = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const geography_1 = require("../../../geography");
const common_1 = require("../class/common");
const constants_1 = require("./constants");
exports.NAMESPACE = 'Culligan.Device.Marker.Row';
exports.Percent = effect_1.Schema.Int.pipe(effect_1.Schema.between(0, 100)).annotations({
    identifier: `${exports.NAMESPACE}.Percent`,
});
exports.Bit = effect_1.Schema.Literal(0, 1).annotations({ identifier: `${exports.NAMESPACE}.Bit` });
exports.MarkerRow = effect_1.Schema.Struct({
    id: common_1.Id,
    v: effect_1.Schema.Int,
    w: effect_1.Schema.Number,
    /** Source document `_ts`, in seconds */
    s: effect_1.Schema.Number,
    t: effect_1.Schema.String,
    /** Loose so a reader on an older domain version still accepts the row */
    m: effect_1.Schema.String,
    is: effect_1.Schema.NullOr(effect_1.Schema.String),
    om: effect_1.Schema.NullOr(effect_1.Schema.String),
    r: effect_1.Schema.NullOr(effect_1.Schema.String),
    /** Raw stored `status.connection.online`, filtered on exactly like the database query */
    cf: effect_1.Schema.NullOr(exports.Bit),
    /** Decoded (legacy-merged) `connectionStatus.online`, used for the pin colour */
    on: exports.Bit,
    la: geography_1.Latitude,
    lo: geography_1.Longitude,
    al: effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }),
    pf: effect_1.Schema.optionalWith(exports.Percent, { exact: true }),
    pc: effect_1.Schema.optionalWith(exports.Percent, { exact: true }),
    pe: effect_1.Schema.optionalWith(exports.Percent, { exact: true }),
    df: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
}).annotations({ identifier: `${exports.NAMESPACE}.MarkerRow` });
exports.MarkerTombstone = effect_1.Schema.Struct({
    id: effect_1.Schema.String,
    v: effect_1.Schema.Int,
    w: effect_1.Schema.Number,
    x: effect_1.Schema.Literal('unlocated', 'deleted'),
    d: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    ttl: effect_1.Schema.Number,
}).annotations({ identifier: `${exports.NAMESPACE}.MarkerTombstone` });
exports.MarkerMeta = effect_1.Schema.Struct({
    id: effect_1.Schema.Literal(constants_1.META_ID),
    v: effect_1.Schema.Int,
    heartbeatAt: effect_1.Schema.Number,
    lagSeconds: effect_1.Schema.Number,
    caughtUpAt: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    caughtUpVersion: effect_1.Schema.optionalWith(effect_1.Schema.Int, { exact: true }),
}).annotations({ identifier: `${exports.NAMESPACE}.MarkerMeta` });
exports.SweepState = effect_1.Schema.Struct({
    id: effect_1.Schema.Literal(constants_1.SWEEP_ID),
    continuation: effect_1.Schema.NullOr(effect_1.Schema.String),
    passStartedAt: effect_1.Schema.Number,
    lastRunAt: effect_1.Schema.Number,
    lastCompletedAt: effect_1.Schema.optionalWith(effect_1.Schema.Number, { exact: true }),
    scanned: effect_1.Schema.Int,
    tombstoned: effect_1.Schema.Int,
    requestCharge: effect_1.Schema.Number,
}).annotations({ identifier: `${exports.NAMESPACE}.SweepState` });
exports.decodeRow = effect_1.Schema.decodeUnknownEither(exports.MarkerRow);
const isTombstone = (u) => typeof u === 'object' && u !== null && 'x' in u && typeof u.x === 'string';
exports.isTombstone = isTombstone;
const sameTags = (a, b) => {
    if (a === b)
        return true;
    if (a === undefined || b === undefined)
        return false;
    return a.length === b.length && a.every((tag, i) => tag === b[i]);
};
// Ignores the writer clock `w` and the source `_ts` `s`, so an unchanged marker skips the write.
const equivalent = (a, b) => a.id === b.id &&
    a.v === b.v &&
    a.t === b.t &&
    a.m === b.m &&
    a.is === b.is &&
    a.om === b.om &&
    a.r === b.r &&
    a.cf === b.cf &&
    a.on === b.on &&
    a.la === b.la &&
    a.lo === b.lo &&
    a.pf === b.pf &&
    a.pc === b.pc &&
    a.pe === b.pe &&
    a.df === b.df &&
    sameTags(a.al, b.al);
exports.equivalent = equivalent;
// The grace period keeps a deploy skew between writer and domain from blanking devices.
const isVisible = (row, nowMs) => row.df === undefined || nowMs - row.df < constants_1.DECODE_FAILURE_GRACE_MS;
exports.isVisible = isVisible;
const tombstone = (id, x, nowMs, version = constants_1.RULES_VERSION) => ({
    id,
    v: version,
    w: nowMs,
    x,
    ...(x === 'deleted' && { d: nowMs }),
    ttl: constants_1.TOMBSTONE_TTL_SECONDS,
});
exports.tombstone = tombstone;
//# sourceMappingURL=row.js.map